import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

// @ts-ignore
import { Link } from "react-router-dom";

import Constants from "../../../data/Constants";

const Wrapper = styled.div`
  color: #FFFFFF;
  display: flex;
  flex-direction: column;
  padding: 10%;
  background-color: #737373;
  min-height: 100%;

  h3 {
    color: #FFFFFF;
    font-family: Mapfre-Bold;
    font-size: 4.5rem;
    line-height: 0.87em;
    margin-bottom: 0.8em;
  }

  .bps-menu__description {
    font-family: Mapfre-Light;
    font-size: 0.9375rem;
    line-height: 1.33em;
    margin-bottom: 4em;
  }

  .bps-menu__buttons {
    border-top: 3px solid #F7F4F3;
    display: flex;
    flex-direction: column;
    font-size: 0.8125rem;
    padding-top: 4.69em;
    width: fit-content;

    & button {
      background-color: #FFFFFF;
      border: none;
      color: #B3001E;
      font-family: Mapfre-Black;
      font-size: 1.0625rem;
      margin-bottom: 2.15em;
      padding-top: 1em;
      padding-bottom: 1em;
      padding-left: 2em;
      padding-right: 2em;
      width: 100%;
    }
  }
`;

const BpsMainMenu = () => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <h3>{ t('bps.title') }</h3>
      <p className='bps-menu__description'>
        { t('bps.description') }
      </p>
      <div className='bps-menu__buttons'>
        <Link to={ Constants.routes.bpsRegions }>
          <button>
            { t('bps.regions1') }
          </button>
        </Link>
        <Link to={ Constants.routes.bpsProportion }>
          <button>
            { t('bps.regions2') }
          </button>
        </Link>
      </div>
    </Wrapper>
  )
};

export default BpsMainMenu;
